import { inject } from 'mobx-react';
import * as React from 'react';
import { InjectTranslate } from './app';

export class AppFooterC extends React.Component<InjectTranslate> {
  public render() {
    const { t } = this.props;

    return (
      <div className="app-footer container">
        <p dangerouslySetInnerHTML={{ __html: t('chrome.footer_html') }}/>
      </div>
    );
  }
}

export const AppFooter: React.ComponentClass = inject('t')(AppFooterC);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/app/app-footer.tsx